import {getSelectedPaymentOption} from '../../selectors';
import getAvailableArvatoPaymentOptionsFromState from './getAvailableArvatoPaymentOptionsFromState';

export default state => getAvailableArvatoPaymentOptionsFromState(state)?.[getSelectedPaymentOption(state).selectedSubPaymentOptionIndex];
